import { cn } from "helpers/classNames";

type Props = {
  className?: string;
};
export const ProxyAssignmentIcon = ({ className }: Props) => (
  <span
    className={cn(
      "inline-flex h-4 w-4 items-center justify-center rounded-full bg-gradient-to-r from-indigo-300 via-rose-300 to-pink-300 text-[10px]/[10px] font-semibold text-white",
      className,
    )}
  >
    H
  </span>
);
